import { render, staticRenderFns } from "./top-button.vue?vue&type=template&id=537e7fba&scoped=true&"
import script from "./top-button.vue?vue&type=script&lang=js&"
export * from "./top-button.vue?vue&type=script&lang=js&"
import style0 from "./top-button.vue?vue&type=style&index=0&id=537e7fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e7fba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537e7fba')) {
      api.createRecord('537e7fba', component.options)
    } else {
      api.reload('537e7fba', component.options)
    }
    module.hot.accept("./top-button.vue?vue&type=template&id=537e7fba&scoped=true&", function () {
      api.rerender('537e7fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/top-button.vue"
export default component.exports